export default ({
  key: pressedKey = "Enter",
  target = {
    blur: () => {
      if (process.env.NODE_ENV !== "production")
        console.log("Target is undefined!"); // eslint-disable-line no-console
    },
  },
} = {}) => pressedKey === "Enter" && target.blur();
